// extracted by mini-css-extract-plugin
export var image = "index-module--image--2addf";
export var imageWrapper = "index-module--imageWrapper--8054b";
export var info = "index-module--info--f20e4";
export var promotionLink = "index-module--promotionLink--534b4";
export var promotionsPanelWrapper = "index-module--promotionsPanelWrapper--2243b";
export var secondaryInfo = "index-module--secondaryInfo--64ab9";
export var tag = "index-module--tag--bae80";
export var text = "index-module--text--38140";